<template>
  <div>
    <!-- <div ref="popupContent">
      <template v-if="info.orderId">
        <div class="marker-popup">
          <div v-if="['0', '1'].includes(info.orderStatus)" class="status" :class="'status' + info.orderStatus">{{orderStatusList[0]}}</div>
          <div v-else-if="['2', '3'].includes(info.orderStatus)" class="status" :class="'status' + info.orderStatus">{{orderStatusList[Number(info.orderStatus) - 1]}}</div>
          <div class="popup-content">
            <div class="lineBlock">
              <p>工单类型：</p>
              <p>{{info.orderTypeName || '--'}}</p>
            </div>
            <div class="lineBlock">
              <p>截止日期：</p>
              <p>{{info.orderDate || '--'}}</p>
            </div>
            <div class="lineBlock">
              <p>工单详情：</p>
              <p>{{info.orderContent || '--'}}</p>
            </div>
            <div class="lineBlock">
              <p>现场图像：</p>
              <div class="fileList" v-if="info.fileList && info.fileList.length > 0">
                <div class="fileBlock" v-for="(items, index) in info.fileList" :key="index">
                  <el-image
                    v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                    :src="items.filePrefix + items.fileUrl"
                    :preview-src-list="info.fileList | imgListFormat"
                    fit="fill">
                  </el-image>
                  <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                  </video>
                </div>
              </div>
            </div>
            <div class="lineBlock">
              <p>反馈图像：</p>
              <div class="fileList" v-if="info.fbFileList && info.fbFileList.length > 0">
                <div class="fileBlock" v-for="(items, index) in info.fbFileList" :key="index">
                  <el-image
                    v-if="imgTypeList.find((itemx) => itemx === items.fileType)"
                    :src="items.filePrefix + items.fileUrl"
                    :preview-src-list="info.fbFileList | imgListFormat"
                    fit="fill">
                  </el-image>
                  <video v-if="videoTypeList.find((itemx) => itemx === items.fileType)" controls="controls" :src="items.filePrefix + items.fileUrl" :preview-src-list="[items.filePrefix + items.fileUrl]" fit="fill">
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div> -->

    <el-drawer :size="'500px'" direction="rtl" title="审批详情" :visible.sync="processVisible">
      <instance-preview v-if="processVisible" :instance-id="selectInstance"
        @handler-after="processVisible = false"></instance-preview>
    </el-drawer>
  </div>
</template>

<script>
import InstancePreview from '@/views/wflow/workspace/approval/ProcessInstancePreview'
// import vjmap from 'vjmap'
export default {
  name: 'WorkPlanCenter',
  components: { InstancePreview },
  data () {
    return {
      processVisible: false,
      selectInstance: '',
      markerList: [],
      imgTypeList: ['jpeg', 'jpg', 'png'],
      videoTypeList: ['mp4', 'mov'],
      typeList: ['反馈', '审核', '转办', '关闭'],
      orderStatusList: ['未完成', '已完成', '已关闭'],
      info: {},
      markerPopup: null
    }
  },
  filters: {
    imgListFormat (list) {
      const imgTypeList = ['jpeg', 'jpg', 'png']
      const imgList = []
      list.forEach((info) => {
        if (imgTypeList.find((items) => items === info.fileType)) {
          imgList.push(info.filePrefix + info.fileUrl)
        }
      })
      return imgList || []
    }
  },
  watch: {
    '$route.path' (newPath, oldPath) {
      // 路由变化时的处理逻辑
      console.log('路由从', oldPath, '变化到', newPath)
      this.clearMap()
      this.listen()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    isOrderPage () {
      return this.$route.path.indexOf('taskOrder') >= 0
    }
  },
  created () {
    this.listen()
  },
  beforeDestroy () {
    this.removeMarkers()
    this.$event.$off('task-order-init')
    this._map && this._map.off('click', this.mapClick)
  },
  methods: {
    listen () {
      console.log('mapAction')
      this.$event.$off('task-order-init')
      if (this.isOrderPage) {
        this.$event.$on('task-order-init', (month) => {
          this.clearMap()
          console.log('mapAction task-order-init')
          this.getTrackList(month).then(res => {
            if (this._map) {
              this.addList(res.list || [])
            } else {
              const interval = setInterval(() => {
                this._map = this.$parent.$children[0]._map
                if (this._map) {
                  interval && clearInterval(interval)
                  this.addList(res.list || [])
                }
              }, 200)
            }
          })
        })
      }
    },
    clearMap () {
      if (this.markerPopup) {
        this.markerPopup.remove()
      }
      this.markerOffClick()
      this.removeMarkers()
    },

    // 获取工单列表(带附件)
    getTrackList (month) {
      const startTime = this.$dayjs(month).startOf('month').format('YYYY-MM-DD')
      const endTime = this.$dayjs(month).endOf('month').format('YYYY-MM-DD')
      return this.$axios.get(this.$apis.process.selectLcWorkOrderByPage, {
        projectId: this.projectId,
        startTime,
        endTime
      })
    },
    getMarkerEl (iconPath, w, h) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url(${iconPath})`
      el.style.width = w || '40px'
      el.style.height = h || '40px'
      el.style.backgroundSize = '100%'
      return el
    },
    // 删除地图列表打点信息
    removeMarkers () {
      this.markerList.forEach(marker => {
        marker.off('click', this.markerClick)
        marker.remove()
      })
      if (this.markerPopup) {
        this.markerPopup.setHTML('')
      }
      this.markerList = []
      if (this._map) {
        const markers = this._map.getMarkers()
        if (markers && markers.length) {
          markers.forEach(info => {
            info.remove()
          })
        }
        console.log('markers', this._map.getMarkers())
      }
    },
    getIcon (status) {
      let icon = require('../../assets/img/icon/issue/normal.svg')
      switch (status) {
        case '1':
          icon = require('../../assets/img/icon/issue/unfinished.svg')
          break
        case '2':
          icon = require('../../assets/img/icon/issue/finished.svg')
          break
        case '3':
        case '4':
        case '5':
          icon = require('../../assets/img/icon/issue/close.svg')
          break
      }
      return icon
    },
    addList (list, type) {
      if (!(type && type === 'add')) {
        this.removeMarkers()
      }
      ;(list || []).forEach(info => {
        if (info.longitude && info.latitude) {
          const el = this.getMarkerEl(this.getIcon(info.orderStatus))
          const marker = new vjmap.Marker({
            element: el,
            anchor: 'bottom'
          })
          marker.setLngLat([info.longitude, info.latitude]).addTo(this._map)
          marker.extData = { ...info }
          marker.on('click', this.markerClick)
          this.markerList.push(marker)
        }
      })
      this.$parent.$children[0].setFitMarkers()
    },
    markerClick (e) {
      this.showMarkerPopup(e.target.extData)
    },
    markerOffClick () {
      this.markerList.forEach(marker => {
        marker.off('click', this.markerClick)
      })
    },
    showMarkerPopup (data) {
      console.log('showMarkerPopup', data.orderId)
      if (this.markerPopup) {
        this.markerPopup.setHTML('')
      } else {
        this.markerPopup = new vjmap.Popup({ closeButton: false })
      }
      const idText = 'orderId'
      const ind = this.markerList.findIndex(info => info.extData && info.extData[idText] === data[idText])
      if (ind >= 0) {
        const marker = this.markerList[ind]
        this.info = { ...data }
        console.log('infofofofofofo', this.info)
        this.processVisible = true
        this.selectInstance = this.info.processId
        // this.$nextTick(() => {
        //   this.markerPopup.setDOMContent(this.$refs.popupContent)
        //   marker.setPopup(this.markerPopup)
        //   if (!this.markerPopup.isOpen()) {
        //     marker.togglePopup()
        //   }
        // })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
  .marker-popup {
      margin: -20px 20px 40px;
      .status {
        display: inline-block;
        position: relative;
        width: auto;
        height: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        font-size: 12px;
        color: #FEFEFE;
        line-height: 15px;
        background: #F5A623;
        padding: 2px 8px;
        &::before {
          content: "";
          position: absolute;
          right: -5px;
          bottom: 0;
          width: 9px;
          height: 100%;
          background: #F5A623;
          transform: skewX(25deg);
        }
        &.status2, &.status2::before  {
          background: #39C44A;
        }
        &.status3, &.status3::before  {
          background: #ABABAB;
        }
      }
      .popup-content {
        width: 570px;
        height: auto;
        background: #FFFFFF;
        padding: 20px;
        box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
        .lineBlock {
          display: flex;
          font-family: PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #000000;
          margin-bottom: 16px;
          p {
            flex-shrink: 0;
          }
        }
        .fileList {
          display: flex;
          flex-wrap: wrap;
          width: calc(100% + 10px);
        }
        .fileBlock {
          width: 70px;
          height: 70px;
          margin: 0 10px 10px 0;
          &:last-child {
            margin-right: 0;
          }
          .el-image {
            width: 100%;
            height: 100%;
          }
          video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
</style>
